/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.headers.common["Prodtrack-api-version"] = "latest";

const defaultRequest = axios;

const tableRequest = axios.create();

tableRequest.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.status === 404) {
            window.location.replace("/404_not_found");
        }
        if (error.response.status === 403) {
            window.location.replace("/403_forbidden");
        }
        return Promise.reject(error);
    }
);

export { tableRequest };

export default defaultRequest;
